function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "bgq7a",
  d: "M868.09 434.987v-40.26L905 414.52l36.91-19.773v40.24zm37.072-70.97l7.046 5.347h-14.083zm28.978 22.058l6.496 4.95-6.496 3.474zm-54.599-12.688h50.63l.046 9.23h-.167v14.03l-25.019 13.36-25.49-13.626zm-10.074 17.632l5.984-4.56v7.761zm64.723-21.645h-15.401L905.156 359l-13.617 10.374H875.45v12.068L864 390.228V439h82v-48.808l-11.852-9.074z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", {
  transform: "translate(-864 -359)"
}, React.createElement("use", {
  fill: "#62ca31",
  xlinkHref: "#bgq7a"
})));

var SvgConfirm = function SvgConfirm(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 82,
    height: 80,
    viewBox: "0 0 82 80",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgConfirm, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/confirm.3a741257.svg";
export { ForwardRef as ReactComponent };